<template>
  <div>
    <el-form class="appear-content">
      <el-form-item label="出现方式/来源渠道" class="title-level1">
      </el-form-item>
      <el-form-item label="出现方式:" class="require">
        <el-select
          v-model="data.appear_id"
          placeholder="请选择出现方式"
          clearable
          @change="
            () => {
              data.source_id = '';
              sourceList = [];
              getSourceTypeKVListApi();
            }
          "
        >
          <el-option
            v-for="item in studentAppearLabelList"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="来源渠道:" class="require">
        <el-select
          v-model="data.source_id"
          placeholder="请选择来源渠道"
          clearable
          @focus="
            () => {
              if (!data.appear_id) {
                $message({
                  type: 'warning',
                  message: '请先选择出现方式',
                });
              }
            }
          "
        >
          <el-option
            v-for="item in sourceList"
            :key="item.source_id"
            :label="item.name"
            :value="item.source_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";

export default {
  props: ["originData"],
  data() {
    return {
      data: {
        appear_id: "",
        source_id: "",
      },
      studentAppearLabelList: [],
      sourceList: [],
    };
  },
  watch: {
    originData: {
      handler() {
        this.data = this.originData;
        this.getSourceTypeKVListApi();
      },
    },
    data: {
      handler() {
        this.$emit("change", this.data);
      },
      deep: true,
    },
  },
  created() {
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
      status: 1,
    }).then((res) => {
      this.studentAppearLabelList = res.data.list;
    });
  },
  methods: {
    getSourceTypeKVListApi() {
      if (!this.data.appear_id) {
        return false;
      }
      sourceTypeSelectListApi({
        appear_id: this.data.appear_id,
        status: 1,
      }).then((res) => {
        if (res.error_code === 0) {
          this.sourceList = res.data.list;
        }
      });
    },
    // 活动类型列表下拉
    handleTypeVisible(...rest) {
      if (rest[0]) {
        this.getActivityTypeListList();
      }
    },
    // 来源渠道列表下拉
    handleSourceVisible(evt) {
      if (evt) {
        if (!this.data.appear_id) {
          this.sourceList = [];
          return this.$message({
            message: "请选择出现方式",
            type: "warning",
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title-level1 {
  color: rgba(92, 93, 94, 1);
}
</style>
